import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IntegrationCode } from 'src/lib/fliko/enums/integrationCode';
import { EstateData } from 'src/lib/fliko/models/estate/estate.data';
import { NoteType } from 'src/lib/fliko/models/notes/notes.data';
import { ResidentType } from 'src/lib/fliko/models/person/resident.data';
import { RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { SubscribeComponent } from 'src/app/shared/classes/subscribe-component';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { UserCommList } from '../../../services/models/users-table.data';
import { UnitResidentViewModel } from '../../../services/models/users-view-models';
import { UsersCommDataService } from '../../../services/users-comm-data.service';

@Component({
  selector: 'app-users-comm-apartment-details',
  templateUrl: './users-comm-apartment-details.component.html',
  styleUrls: ['./users-comm-apartment-details.component.scss']
})
export class UsersCommApartmentDetailsComponent extends SubscribeComponent {
  public estate!: EstateData;

  public residents: UnitResidentViewModel[] = [];
  public bankAccount: string = '';

  public canEdit = false;
  public showUnitCodes = false;

  public unitCodeTypes = IntegrationCode.enumValues();

  NoteType = NoteType;
  RentalUnitType = RentalUnitType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UserCommList.ApartmentElement,
    private dialogRef: MatDialogRef<UsersCommApartmentDetailsComponent>,
    private router: Router,
    private userCommData: UsersCommDataService,
    private ctxDS: ContextDataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscription$.add(
      this.ctxDS.currentEstate$.subscribe((estate) => {
        if (estate) {
          this.estate = estate;
        }
      })
    );

    this.getData();

    this.subscription$.add(
      this.ctxDS.contextPerms$.subscribe((perms) => (this.canEdit = perms?.superAdmin || !!perms?.ePerm?.user?.edit))
    );
  }

  public getData(): void {
    this.subscription$.add(
      this.userCommData.getUnitsResidencyData$(RentalUnitType.APARTMENT, [this.data.id]).subscribe((unitData) => {
        const unit = unitData[0];
        if (unit) {
          this.bankAccount = unit.bankAccount;
          this.residents = unit.residents.filter((r) => r.type === ResidentType.LANDLORD || !!r.currentTenancies?.length);
        }
      })
    );
  }

  public onEdit(): void {
    if (!this.canEdit) return;
    this.router.navigate(['/users/apartments/edit', this.data.unit.id]);
    this.dialogRef.close();
  }

  public getParkingSpotsLabel(): string {
    return this.data?.parkings?.map((p) => p.unit.number)?.join(', ') || '-';
  }

  public getStorageRoomLabel(): string {
    return this.data?.storages?.map((s) => s.unit.number)?.join(', ') || '-';
  }
}
